import React from 'react';
import { brandConfig } from '../config/brand';

/** Column heights of the trace, as a fraction of the rig height. */
const WAVE_HEIGHTS = [0.4, 0.7, 0.5, 0.95, 0.6, 0.85, 0.45, 0.7];

/**
 * Mirrored bar rig shared by every "Loading your workspace…" screen — the Suspense fallback
 * in App.tsx and Dashboard's own loading state. The pre-React boot loader in index.html
 * carries a hand-written copy of this markup (it runs before any bundle exists), so keep the
 * two in sync.
 *
 * The `tcWave` keyframe and the reduced-motion guard live in src/main.css, not in a
 * component <style> block: these loaders render *before* the component that would carry the
 * keyframe, which is exactly why the `loadingBar` bar this replaces never animated.
 */
export const WaveformRig: React.FC<{ height?: number }> = ({ height = 96 }) => (
    <div style={{ position: 'relative', display: 'flex', alignItems: 'center', gap: 7, height }}>
        {/* Baseline the trace is mirrored around. */}
        <div style={{
            position: 'absolute', left: -14, right: -14, top: '50%', height: 1, background: '#cbd0d7',
        }} />
        {WAVE_HEIGHTS.map((h, i) => (
            <div key={i} style={{
                display: 'flex', flexDirection: 'column', justifyContent: 'center',
                height: '100%', width: 9,
            }}>
                <div className="tc-wave-bar" style={{
                    height: `${h * 50}%`, borderRadius: '3px 3px 0 0',
                    background: `linear-gradient(180deg, #fb923c, ${brandConfig.primaryColor})`,
                    transformOrigin: 'bottom',
                    animation: `tcWave 1.6s ease-in-out ${i * 0.1}s infinite`,
                }} />
                {/* Reflection: same shape knocked back, so the top half stays the read. */}
                <div className="tc-wave-bar" style={{
                    height: `${h * 50}%`, borderRadius: '0 0 3px 3px',
                    background: 'linear-gradient(0deg, rgba(255,90,10,.25), rgba(255,90,10,.7))',
                    transformOrigin: 'top',
                    animation: `tcWave 1.6s ease-in-out ${i * 0.1}s infinite`,
                }} />
            </div>
        ))}
    </div>
);
